import { render } from "./Ar.vue?vue&type=template&id=70069a67&scoped=true"
import script from "./Ar.vue?vue&type=script&lang=js"
export * from "./Ar.vue?vue&type=script&lang=js"

import "./Ar.vue?vue&type=style&index=0&id=70069a67&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70069a67"

export default script